import { Action } from 'redux';
import { MerchantState } from "../state";
import { MerchantActionTypes as actionTypes } from '../actions/action_types';
const {
    SET_MERCHANT_DATA,
} = actionTypes;

export const actions = {
    setMerchantData: (data: any) => (
        {
            type: actionTypes.SET_MERCHANT_DATA,
            payload: data
        }
    )
}
type MerchantAction = Action & { payload: any };
export const reducers = (state: MerchantState = { merchant: null }, action: MerchantAction) => {
    switch (action.type) {
        case SET_MERCHANT_DATA: {
            return {
                merchant: action?.payload || null
            };
        }
        default:
            break;
    }
    return state;
};

